import React, { useEffect, useState } from 'react';
import { Button, Image, Space, Drawer, Layout, theme, Typography } from 'antd';
import { MenuUnfoldOutlined } from '@ant-design/icons';
import './AppHeader.css';
import { Link, useLocation } from 'react-router-dom';
import UserDropdown from '../UserDropdown';
import { Sidenav } from '../Sidenav';
import Title from 'antd/es/typography/Title';

const { Header } = Layout;

export default function AppHeader() {
  // Drawer states
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  // primary theme
  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <Header className="app-header">
      {/* <h4 style={{ margin: 0, color: colorPrimary, fontSize: '1.3rem' }}>Stock Brokerage System</h4> */}

      <Button
        className="mobileMenuBtn"
        icon={<MenuUnfoldOutlined style={{ color: colorPrimary }} />}
        onClick={showDrawer}
        type={'link'}
        size={'large'}
      />
      <Image
        src={`${process.env.PUBLIC_URL}/images/uab-security-removebg.png`}
        width={200}
        preview={false}
      />
      <Drawer
        title={
          <Typography.Title
            level={5}
            style={{ margin: 0, color: 'whitesmoke', fontSize: '1.3rem' }}
          >
            Stock Brokerage System
          </Typography.Title>
        }
        style={{
          backgroundImage: 'linear-gradient(#3FB350, #503fb3)',
        }}
        placement="left"
        onClose={onClose}
        open={open}
      >
        <Sidenav />
      </Drawer>
    </Header>
  );
}
